import { lightBell, mainBell } from './../utils/sounds';

const round = (minutes, timeUnit, name, exercises, setState, finishedCallback) => {
  let seconds = minutes * 60 + 1;
  const totalSeconds = minutes * 60;

  return {
    start: () => {
      var x = setInterval(function() {
        seconds--;

        let nextExercise = null;
        const exerciseIndex = Math.floor(seconds / timeUnit),
              exercise = exercises[exerciseIndex],
              secondsUntilNext = seconds % timeUnit;

        if (exercises[exerciseIndex - 1]) {
          nextExercise = exercises[exerciseIndex - 1];
        } else {
          nextExercise = null;
        }

        if (
          secondsUntilNext === (timeUnit - 1) &&
          (seconds !== (totalSeconds - 1)) &&
          (seconds !== 0)
        ) { lightBell(); }

        if (seconds >= 0) {
          setState({
            phase: name,
            seconds: seconds,
            exercise: exercise,
            nextExercise: nextExercise,
            secondsUntilNext: secondsUntilNext
          });

          return seconds;
        } else {
          mainBell();
          finishedCallback();
          clearInterval(x);
        }
      }, 1000);
    }
  }
}

export default round;
